var amazeal = {
    _ready: [],
    is_ready: false
}
amazeal.ready = function(cb){
    if (amazeal.is_ready) {cb()}
    amazeal._ready.push(cb);
}
amazeal.invoke_ready = function(){
    amazeal._ready.forEach(function(r){ r(); })
    is_ready = true;
}

amazeal.GetHat = function(id, cb){
    $.get("https://amazembroidery.link/api/get.php/"+id).done(function(data){
        cb(data);
    })
}

amazeal.GetAllHats = function(cb){
    $.get("https://amazembroidery.link/api/list.php").done(function(data){
        cb(data);
    })
}

amazeal.hats = {
    data: [],
    global: {}
}
amazeal.hats.global.getFullName = function(){
    return `${this.make} - ${this.model} - ${this.variant}`;
}
amazeal.hats.load = function(){
    return new Promise(function(resolve, reject){
        $.get("https://amazembroidery.link/api/list.php").done(function(data){
            amazeal.hats.data = data
            data.forEach(function(hat, index, hats){
                hats[index].getFullName = amazeal.hats.global.getFullName;
            })
            resolve(data);
        }).fail(function(err){
            reject(err);
        })
    })
}

amazeal.hats.getHatByID = function(id){
    var result;
    this.data.forEach(function(e){
      if (id == e.id){ result = e; }
    });
    return result;
}

// Init
amazeal.load = function(){
    amazeal.hats.load()
    .then(amazeal.invoke_ready).catch(console.log)
}();

amazeal.ready(function(){
    var hat = amazeal.hats.getHatByID("6cbb1a5076fc58ca5a99bf4e38296c44")
    console.log(hat.getFullName())
})
